'use client'

import Link from 'next/link'
import { CalendarDaysIcon } from 'lucide-react'

import { Media } from '@/components/Media'
import { RevealSection } from '@/components/RevealSection'
import RichText from '@/components/RichText'
import { Button } from '@/components/ui/button'
import { useEventsContext } from '@/providers/EventsProvider'
import { eventCoverImage } from '@/utilities/events/eventCoverImage'
import { formatDateTime } from '@/utilities/global/formatDateTime'

const FeaturedEvent = () => {
  const { featured } = useEventsContext()

  if (!featured) return null

  const { name, general, slug } = featured

  return (
    <>
      <RevealSection
        stagger
        className="relative z-20 wrapper grid grid-cols-1 gap-6 pb-12 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:gap-14 lg:pb-16 xl:gap-20"
      >
        <Media
          loading="eager"
          resource={eventCoverImage(featured)}
          htmlelement={null}
          context={'card'}
          width={450}
          height={450}
          pictureClassName="block aspect-square w-full overflow-hidden object-cover"
          imgClassName="aspect-square size-full rounded-2xl object-cover object-center"
        />
        <div className="flex h-full flex-col justify-center gap-4 lg:gap-6 lg:pr-8">
          <div className="flex items-center gap-2">
            <CalendarDaysIcon className="size-4.5 text-muted-foreground lg:size-6" />
            <span className="text-reg font-medium text-muted-foreground lg:text-lg">
              {formatDateTime(general.startAt)}
            </span>
          </div>
          <h1 className="font-display text-3xl leading-1-1 font-normal text-balance text-foreground lg:text-4xl xl:text-5xl">
            {name}
          </h1>
          {general.description && (
            <RichText
              className="line-clamp-5 overflow-hidden font-body text-base text-ellipsis text-card-foreground lg:text-xl"
              data={general.description}
            />
          )}
          <Button asChild variant="accent" className="w-fit">
            <Link href={`/events/${slug}`}>Read more</Link>
          </Button>
        </div>
      </RevealSection>
      <RevealSection stagger className="mb-12 lg:mb-16">
        <hr className="w-full border-border" />
      </RevealSection>
    </>
  )
}

export default FeaturedEvent
